<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-air-conditioner`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.475 36.61l1.414 1.415a1 1 0 010 1.414l-4.243 4.243a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l4.243-4.243a1 1 0 011.414 0zm11.646 0l1.415 1.415a1 1 0 010 1.414l-4.243 4.243a1 1 0 01-1.414 0l-1.415-1.414a1 1 0 010-1.414l4.243-4.243a1 1 0 011.414 0zm12 0l1.414 1.415a1 1 0 010 1.414l-4.242 4.243a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l4.242-4.243a1 1 0 011.414 0zM44.238 6C45.211 6 46 6.658 46 7.47v25.06c0 .812-.789 1.47-1.762 1.47H3.762C2.789 34 2 33.342 2 32.53V7.47C2 6.659 2.789 6 3.762 6h40.476zM42 27H6v3h36v-3zm0-17H6v13h36V10zm-5 5a1 1 0 011 1v2a1 1 0 01-1 1H27a1 1 0 01-1-1v-2a1 1 0 011-1h10z"/></svg>
</template>
<script>

export default {
  name: 'IconAirConditioner',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
